export default [
    {
        file: "pic1.jpg",
        caption: "1955, the Armenian College scouting group"
    },
    {
        file: "pic2.jpg",
        caption: "1958, my class"
    },
    {
        file: "pic3.jpg",
        caption: "1960, Armenian College Cross Country Team"
    },
    {
        file: "pic4.jpg",
        caption: "1961, the author with friends back home"
    },
    {
        file: "pic5.jpg",
        caption: "1955, Armenian College boyscouts troop"
    },
    {
        file: "pic6.jpg",
        caption: "1959, our clothing manager"
    },
    {
        file: "pic7.jpg",
        caption: "1960, the Araratian Combo"
    },
    {
        file: "pic8.jpg",
        caption: "1957, preparing the field for the sports competition"
    },
    {
        file: "pic9.jpg",
        caption: "1954, the school soccer team"
    },
    {
        file: "pic10.jpg",
        caption: "1956, after coming down from a sleepless night"
    },
    {
        file: "pic11.jpg",
        caption: "1957, Armenian College soccer champions"
    },
    {
        file: "pic12.jpg",
        caption: "1955, ready for church"
    },
    {
        file: "pic13.jpg",
        caption: "1959, Armenian College boy scouts"
    },
    {
        file: "pic14.jpg",
        caption: "1954, on our way to Darjeeling"
    },
    {
        file: "pic15.jpg",
        caption: "1953, Armenian College boxing representatives"
    },
    {
        file: "pic16.jpg",
        caption: "1954, having fun in Darjeeling"
    },
    {
        file: "pic17.jpg",
        caption: "1958, the school hockey team"
    },
    {
        file: "pic18.jpg",
        caption: "1956, Armenian College choir group with his Eminence"
    },
    {
        file: "pic19.jpg",
        caption: "1956, The Armenian College choir ensemble"
    },
    {
        file: "pic20.jpg",
        caption: "1959, The author playing Elvis Presley on the rooftop"
    }
]